import React from 'react';
import cn from 'classnames';
import styles from './style.module.scss';

export const Preloader = () => (
  <div className={styles.preloader}>
    <div className={styles['lds-roller']}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export const FlexiblePreloader = () => (
  <div className={styles.flexiblePreloader}>
    <div className={styles['lds-roller']}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export const ButtonPreloader = () => (
  <div className={styles['spinner-box']}>
    <div className={styles['circle-border']}>
      <div className={styles['circle-core']} />
    </div>
  </div>
);

export const ButtonMiniPreloader = () => (
  <div className={styles['lds-ring']}>
    <div className={cn(styles.loader, 'loader')} />
    <div className={cn(styles.loader, 'loader')} />
    <div className={cn(styles.loader, 'loader')} />
    <div className={cn(styles.loader, 'loader')} />
  </div>
);

export const CompactPreloader = () => (
  <div className={styles.compactPreloader}>
    <div className={styles['lds-roller']}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Preloader;
